// @flow
import type { Theme } from '../types';

export const getColorFromTheme = (theme: Theme, type: string): string =>
  theme.colors[type] || theme.colors.neutral;

export default getColorFromTheme;



// WEBPACK FOOTER //
// ./src/themes/utils/getColorFromTheme.js